import { DateFormatsConst } from '@core/constants/date-formats.const';
import { EntityTypesEnum } from '@core/enums/entity-types.enum';
import { NotificationTypesEnum } from '@core/enums/notification-types.enum';
import { DateTimeService } from '@core/services/date-time.service';
import { NotificationInterface } from '../interfaces/notification.interface';

export class NotificationModel {
    id: string;
    entityType: EntityTypesEnum;
    recordID: string;
    notificationType: NotificationTypesEnum;
    isRead: boolean;
    text: string;
    dateCreated: string;
    createdBy: string;

    constructor(
        notification: NotificationInterface,
        dateTimeService: DateTimeService
    ) {
        this.id = notification.id;
        this.entityType = notification.entityType;
        this.recordID = notification.recordID;
        this.notificationType = notification.notificationType;
        this.isRead = notification.isRead;
        this.text = notification.text;
        this.dateCreated = dateTimeService.format(
            notification.dateCreated,
            DateFormatsConst.TIME_WITH_FULL_DATE
        ).replace('AM ', 'am ').replace('PM ', 'pm '); // P.Bruyaka: Dirty hack, but there is no good way to do lowercase am/pm
        this.createdBy = notification.createdBy;
    }
}